import { render } from "./PendingBuilding.vue?vue&type=template&id=878511c6&scoped=true"
import script from "./PendingBuilding.vue?vue&type=script&lang=js"
export * from "./PendingBuilding.vue?vue&type=script&lang=js"

import "./PendingBuilding.vue?vue&type=style&index=0&id=878511c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878511c6"]])

export default __exports__